import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Typography,
} from "@mui/material";
import type { FC } from "react";

export const ClickwrapModal: FC<{
  open: boolean;
  title: string;
  onCancel: () => void;
  onAgree: () => void;
  status: "loading" | "loaded" | "error";
  contentHtml: string;
  contentFormat: string;
  errorMessage?: string;
  onRetry: () => void;
}> = ({
  open,
  title,
  onCancel,
  onAgree,
  status,
  contentHtml,
  contentFormat,
  errorMessage,
  onRetry,
}) => {
  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (reason === "backdropClick") return;
      }}
      disableEscapeKeyDown
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        {status === "loading" ? (
          <Box>
            <LinearProgress sx={{ mb: 2 }} />
            <Typography variant="body2">Loading latest agreement terms...</Typography>
          </Box>
        ) : null}
        {status === "error" ? (
          <Alert severity="error">
            {errorMessage ?? "Couldn't load the agreement. Please retry."}
          </Alert>
        ) : null}
        {status === "loaded" ? (
          <Box
            sx={{
              maxHeight: "60vh",
              overflowY: "auto",
              "& h1, & h2, & h3, & h4": { mt: 0 },
              "& p, & li": { whiteSpace: "pre-wrap" },
            }}
            data-content-format={contentFormat}
            dangerouslySetInnerHTML={{ __html: contentHtml }}
          />
        ) : null}
      </DialogContent>
      <DialogActions>
        {status === "error" ? (
          <Button
            onClick={onRetry}
            variant="contained"
            data-analytics-id="two-way-sms-clickwrap-retry"
          >
            Retry
          </Button>
        ) : null}
        {status === "loaded" ? (
          <>
            <Button onClick={onCancel} data-analytics-id="two-way-sms-clickwrap-cancel">
              Cancel
            </Button>
            <Button
              onClick={onAgree}
              variant="contained"
              data-analytics-id="two-way-sms-clickwrap-agree"
            >
              Agree and Continue
            </Button>
          </>
        ) : null}
      </DialogActions>
    </Dialog>
  );
};
